import {useEffect} from 'react'
import {useParams} from 'react-router-dom'
import {Trans} from 'react-i18next'
import {PammOfferTitle} from './components/Title'
import {useOffers} from '../Accounts/PammManagerSettingsView/components/PammManagerOffers/useOffers'
import messages from '../../assets/messages'
import Loading from '../Common/Loading'
import {Row} from './components/Row'
import {Column} from './components/Column'
import {OfferName} from './components/OfferName'
import {FeeStructure} from './components/FeeStructure'
import {VerticalSpace} from './components/VerticalSpace'
import {Conditions} from './components/Conditions'
import {DecideForm} from './components/DecideForm'
import {WhatHappensNext} from './components/WhatHappensNext'
import {useAcceptedOffers} from './hooks/useAcceptedOffers'
import {useRecordVisit} from './hooks/useRecordVisit'
import {AlreadyAccepted} from './components/AlreadyAccepted'
import {Warning} from './components/Warning'
import {useViewer} from '../../hooks/useViewer'

const clearCookie = (name: string) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;Path=/;`
}

export const PammOffer = () => {
  const params = useParams<{pammManagerId: string; pammOfferId: string}>()
  const managerId = Number(params.pammManagerId)
  const offerId = Number(params.pammOfferId)
  const {loading: loadingOffers, offers} = useOffers(managerId)
  const {loading: loadingViewer, viewer} = useViewer()
  const {loading: loadingAcceptedOffers, acceptedOffers} = useAcceptedOffers()
  const offer = (offers ?? []).find((offer) => offer.id === offerId)
  const alreadyAcceptedOffer = acceptedOffers?.find((acceptedOffer) => acceptedOffer.id === offer?.id)

  const loading = loadingOffers || loadingAcceptedOffers

  useEffect(() => {
    clearCookie('pammOffer')
  }, [])

  useRecordVisit({managerId, offerId})

  if (loading || loadingViewer) return <Loading />

  const ownOffer = offer?.skygroundClientId === viewer.id

  return (
    <>
      <PammOfferTitle />
      {ownOffer && (
        <Warning>
          <Trans {...messages.ownOfferInfo} />
        </Warning>
      )}
      {offer && (
        <>
          <Row>
            <Column>
              <OfferName>{offer.name}</OfferName>
              <FeeStructure offer={offer} />
              <VerticalSpace />
              <Conditions offer={offer} />
              <WhatHappensNext />
            </Column>
            <Column>
              <VerticalSpace />
              {!alreadyAcceptedOffer && <DecideForm disabled={ownOffer} />}
              {alreadyAcceptedOffer && <AlreadyAccepted pammId={alreadyAcceptedOffer.accountId} />}
            </Column>
          </Row>
        </>
      )}
    </>
  )
}
